/*

Class: Services
Description: Début du parcours de réservation d'un service
Author: Franck David

*/



import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Booking from './Booking'
import Buying from './Buying'
import picture from '../../img/default.jpg'
import tools from '../../tools'
import connexion from '../../connexion'
import './Services.css'
import ThemeIcon from '../UI/ThemeIcon'
import Skeleton from '../UI/Skeleton'

class Services extends Component {
	constructor(props) {
		super(props)
		const now = new Date()
		const timestamp = Math.round(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime() / 1000)
		this.state = {
			cart: null,
			service: null,
			service_benefits: null,
			service_benefit: null,
			service_products: null,
			service_reservations: null,
			service_workers: null,
			reservation: null,
			selectedSlot: null,
			selectedSlotCart: null,
			selectedDayCard: null,
			selectedBenefitId: null,
			authSheet: false,
			step: 0,
			error: null,
			timestamp: timestamp,
			mounted: false,
			selectedFamily: null,
			pending_order_slot: null
		}
	}

	componentDidMount() {
		this.props.updateLogs(this.props.history.location.pathname, 'Services')
		this.loadService()
		this.props.updateShell(null, true, this.props.history.location.pathname)
		if (!this.props.icons)
			this.props.fetchIcons()
		this.props.fetchNotifications()
		const pendingId = sessionStorage.getItem('pending_benefit_id')
		if (pendingId)
		{
			sessionStorage.removeItem('pending_benefit_id')
			this.setState({ selectedBenefitId: pendingId })
		}
		const pendingOrderSlotRaw = sessionStorage.getItem('pending_order_slot')
		if (pendingOrderSlotRaw)
		{
			sessionStorage.removeItem('pending_order_slot')
			try
			{
				this.setState({ pending_order_slot: JSON.parse(pendingOrderSlotRaw) })
			}
			catch (err)
			{
				console.log(err)
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.service !== this.state.service)
		{
			const service = this.state.service._id
			this.props.fetchServiceBenefitsByService(service)
			.then(service_benefits => {
				this.setState({ service_benefits: service_benefits })
				if (this.state.pending_order_slot)
					this._applyPendingOrderSlot(service_benefits)
			})
			this.props.fetchServiceReservationsByService(service)
			.then(service_reservations => {
				this.setState({ service_reservations: service_reservations })
			})
			this.props.fetchServiceWorkersByService(service)
			.then(service_workers => {
				this.setState({ service_workers: service_workers })
			})
			this.props.fetchServiceProductsByService(service)
			.then(service_products => {
				for (let i = 0; i < service_products.length; i++)
					service_products[i].quantity = 0
				this.setState({ service_products: service_products })
			})
		}
	}
	
	loadService = () => {
		const services = this.props.services
		const url = this.props.history.location.pathname.substr(10)
		let service = null
		if (services)
		{
			for (let i = 0; i < services.length; i++)
			{
				if (services[i].url === url)
				{
					service = services[i]
					break
				}
			}
		}
		if (service === null || !service.cover)
		{
			this.props.fetchServiceByURL(url, this.props.user.lang)
			.then(service => {
				this.setState({ service: service, mounted: true })
			})
			.catch(err => console.log(err))
		}
		else
			this.setState({ service: service, mounted: true })
	}

	selectSlot = (day, start, end, workers) => {
		const prev = this.state.selectedSlot
		if (prev && prev.day === day && prev.start === start) {
			this.setState({ selectedSlot: null })
		} else {
			this.setState({ selectedSlot: { day, start, end, workers } })
		}
	}

	confirmSlot = () => {
		let { day, start, end, workers } = this.state.selectedSlot
		start = start * 60 + day
		end = end * 60 + day
		workers = tools.clone(workers)
		const reservations = tools.clone(this.state.service_reservations)
		const count_workers = {}
		for (let i = 0; i < workers.length; i++)
			count_workers[workers[i]._id] = 0
		let i = 0
		while (i < reservations.length)
		{
			if (reservations[i].start !== start || reservations[i].end !== end)
			{
				reservations.splice(i, 1)
				continue
			}
			else
				count_workers[reservations[i].service_worker]++
			i++
		}
		let min = null
		for (const [key, value] of Object.entries(count_workers))
		{
			if (min === null || min > value)
				min = value
			if (!key)
				console.log(key)
		}
		for (const [key, value] of Object.entries(count_workers))
		{
			if (value !== min)
			{
				i = 0
				while (i < workers.length)
				{
					if (workers[i]._id === key)
					{
						workers.splice(i, 1)
						break
					}
					i++
				}
			}
		}
		const rand = Math.floor(Math.random() * workers.length)
		const worker = workers[rand]
		const service = {
			service: this.state.service_benefit.service,
			service_benefit: this.state.service_benefit._id,
			service_worker: worker._id,
			start: start,
			end: end,
			answers: null,
			user: this.props.user._id
		}
		this.setState({ step: 2, reservation: service, selectedSlot: null })
	}

	selectSlotCartPreview = (day, start, end) => {
		const prev = this.state.selectedSlotCart
		if (prev && prev.day === day && prev.start === start) {
			this.setState({ selectedSlotCart: null })
		} else {
			this.setState({ selectedSlotCart: { day, start, end } })
		}
	}

	confirmSlotCart = () => {
		const u = this.props.user
		if (!u || u.invite === true) {
			this.setState({ authSheet: true })
			return
		}
		const { day, start, end } = this.state.selectedSlotCart
		this.selectSlotCart(day, start, end)
	}

	_applyPendingOrderSlot = (service_benefits) => {
		const pending = this.state.pending_order_slot
		const sb = (service_benefits && service_benefits.length > 0) ? service_benefits[0] : null
		const reservation = {
			service: this.state.service,
			service_benefit: sb ? sb._id : null,
			cart: this.state.cart,
			start: pending.start,
			end: pending.end,
			answers: null,
			user: this.props.user._id
		}
		this.setState({ step: 1, reservation: reservation, pending_order_slot: null })
	}

	selectSlotCart = (day, start, end) => {
		start = start * 60 + day
		end = end * 60 + day
		const reservations = tools.clone(this.state.service_reservations)
		let i = 0
		while (i < reservations.length)
		{
			if (reservations[i].start !== start || reservations[i].end !== end)
			{
				reservations.splice(i, 1)
				continue
			}
			i++
		}
		const sb = this.state.service_benefits && this.state.service_benefits.length > 0 ? this.state.service_benefits[0] : null
		const service = {
			service: this.state.service,
			service_benefit: sb ? sb._id : null,
			cart: this.state.cart,
			start: start,
			end: end,
			answers: null,
			user: this.props.user._id
		}
		this.setState({ step: 1, reservation: service })
	}

	updateTime = (time) => {
		const todayMidnight = Math.round(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime() / 1000)
		if (time < todayMidnight) return
		this.setState({ timestamp: time })
	}

	_hasAvailableSlot = (timestamp) => {
		const service_benefit = this.state.service_benefit
		const service_workers = this.state.service_workers
		const service_reservations = this.state.service_reservations
		if (!service_benefit || !service_workers || !service_reservations) return false
		const todayMidnight = Math.round(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime() / 1000)
		if (timestamp < todayMidnight) return false
		const date = new Date(timestamp * 1000)
		const year = date.getFullYear()
		const weekday = date.getDay()
		const dayStart = Math.round(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() / 1000)
		// Vérifie open_dates
		let inSeason = false
		for (let i = 0; i < service_benefit.open_dates.length; i++) {
			const od = service_benefit.open_dates[i]
			const start = Math.round(new Date(year, od.start_month - 1, od.start_day).getTime() / 1000)
			const end = Math.round(new Date(year, od.end_month - 1, od.end_day).getTime() / 1000)
			if (dayStart >= start && dayStart <= end) { inSeason = true; break }
		}
		if (!inSeason) return false
		// Vérifie que le jour de la semaine est ouvert
		let weekdayOpen = false
		for (let i = 0; i < service_benefit.open_hours.length; i++) {
			const oh = service_benefit.open_hours[i]
			if ((weekday === 0 && oh.sunday) || (weekday === 1 && oh.monday) ||
				(weekday === 2 && oh.tuesday) || (weekday === 3 && oh.wednesday) ||
				(weekday === 4 && oh.thursday) || (weekday === 5 && oh.friday) ||
				(weekday === 6 && oh.saturday)) { weekdayOpen = true; break }
		}
		if (!weekdayOpen) return false
		// Compte les workers disponibles ce jour
		let nbWorkers = 0
		for (let i = 0; i < service_workers.length; i++) {
			const w = service_workers[i]
			if (w.services.length > 0 && w.services.indexOf(service_benefit._id) === -1) continue
			let inDates = false
			for (let j = 0; j < w.working_dates.length; j++) {
				const wd = w.working_dates[j]
				const start = Math.round(new Date(year, wd.start_month - 1, wd.start_day).getTime() / 1000)
				const end = Math.round(new Date(year, wd.end_month - 1, wd.end_day).getTime() / 1000)
				if (dayStart >= start && dayStart <= end) { inDates = true; break }
			}
			if (!inDates) continue
			for (let j = 0; j < w.working_hours.length; j++) {
				const wh = w.working_hours[j]
				if ((weekday === 0 && wh.sunday) || (weekday === 1 && wh.monday) ||
					(weekday === 2 && wh.tuesday) || (weekday === 3 && wh.wednesday) ||
					(weekday === 4 && wh.thursday) || (weekday === 5 && wh.friday) ||
					(weekday === 6 && wh.saturday)) { nbWorkers++; break }
			}
		}
		if (nbWorkers === 0) return false
		// Si simultané illimité, au moins un worker = dispo
		const simultaneous = service_benefit.simultaneous
		if (simultaneous === null) return true
		const max = nbWorkers * simultaneous
		const duration = service_benefit.duration_hour * 60 + service_benefit.duration_minute
		const interval = service_benefit.interval_hour * 60 + service_benefit.interval_minute
		for (let i = 0; i < service_benefit.open_hours.length; i++) {
			const oh = service_benefit.open_hours[i]
			if (!((weekday === 0 && oh.sunday) || (weekday === 1 && oh.monday) ||
				(weekday === 2 && oh.tuesday) || (weekday === 3 && oh.wednesday) ||
				(weekday === 4 && oh.thursday) || (weekday === 5 && oh.friday) ||
				(weekday === 6 && oh.saturday))) continue
			let start_slot = oh.start_hour * 60 + oh.start_minute
			let end_slot = start_slot + duration
			const deadline = oh.end_hour * 60 + oh.end_minute
			while (end_slot + interval <= deadline) {
				const start_time = start_slot * 60 + dayStart
				const end_time = end_slot * 60 + dayStart
				let reservations = 0
				for (let k = 0; k < service_reservations.length; k++) {
					const r = service_reservations[k]
					if ((r.start <= start_time && r.end > start_time) ||
						(r.start > start_time && r.start < end_time) ||
						(r.end > start_time && r.end < end_time)) reservations++
				}
				if (reservations < max) return true
				start_slot = end_slot + interval
				end_slot = start_slot + duration
			}
		}
		return false
	}

	_findNextAvailableDay = () => {
		for (let i = 1; i <= 365; i++) {
			const t = this.state.timestamp + i * 86400
			if (this._hasAvailableSlot(t)) return t
		}
		return null
	}

	_hasAvailableSlotCart = (timestamp) => {
		const service = this.state.service
		const service_benefits = this.state.service_benefits
		const sb = (service_benefits && service_benefits.length > 0) ? service_benefits[0] : null
		if (!service || !sb) return false
		const date = new Date(timestamp * 1000)
		const year = date.getFullYear()
		const weekday = date.getDay()
		const dayStart = Math.round(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() / 1000)
		const todayMidnight = Math.round(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime() / 1000)
		if (dayStart < todayMidnight) return false
		let inSeason = false
		for (let i = 0; i < sb.open_dates.length; i++) {
			const od = sb.open_dates[i]
			const start = Math.round(new Date(year, od.start_month - 1, od.start_day).getTime() / 1000)
			const end = Math.round(new Date(year, od.end_month - 1, od.end_day).getTime() / 1000)
			if (dayStart >= start && dayStart <= end) { inSeason = true; break }
		}
		if (!inSeason) return false
		const now = Math.floor(Date.now() / 1000)
		const duration = sb.duration_hour * 60 + sb.duration_minute
		const interval = sb.interval_hour * 60 + sb.interval_minute
		const limitSec = (sb.limit_end != null ? Number(sb.limit_end) : 0) * 3600
		for (let i = 0; i < sb.open_hours.length; i++) {
			const oh = sb.open_hours[i]
			if (!((weekday === 0 && oh.sunday) || (weekday === 1 && oh.monday) ||
				(weekday === 2 && oh.tuesday) || (weekday === 3 && oh.wednesday) ||
				(weekday === 4 && oh.thursday) || (weekday === 5 && oh.friday) ||
				(weekday === 6 && oh.saturday))) continue
			if (duration === 0) {
				// full window = 1 slot per open_hours range
				const start_slot = oh.start_hour * 60 + oh.start_minute
				const slotStart = dayStart + start_slot * 60
				if (now + limitSec <= slotStart) return true
			} else {
				let start_slot = oh.start_hour * 60 + oh.start_minute
				let end_slot = start_slot + duration
				const deadline = oh.end_hour * 60 + oh.end_minute
				while (end_slot + interval <= deadline) {
					const slotStart = dayStart + start_slot * 60
					if (now + limitSec <= slotStart) return true
					start_slot = end_slot + interval
					end_slot = start_slot + duration
				}
			}
		}
		return false
	}

	_countSlotsForDay = (timestamp) => {
		const service = this.state.service
		const service_benefits = this.state.service_benefits
		const sb = (service_benefits && service_benefits.length > 0) ? service_benefits[0] : null
		if (!service || !sb) return 0
		const date = new Date(timestamp * 1000)
		const weekday = date.getDay()
		const dayStart = Math.round(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() / 1000)
		const now = Math.floor(Date.now() / 1000)
		const duration = sb.duration_hour * 60 + sb.duration_minute
		const interval = sb.interval_hour * 60 + sb.interval_minute
		const limitSec = (sb.limit_end != null ? Number(sb.limit_end) : 0) * 3600
		let count = 0
		for (let i = 0; i < sb.open_hours.length; i++) {
			const oh = sb.open_hours[i]
			if (!((weekday === 0 && oh.sunday) || (weekday === 1 && oh.monday) ||
				(weekday === 2 && oh.tuesday) || (weekday === 3 && oh.wednesday) ||
				(weekday === 4 && oh.thursday) || (weekday === 5 && oh.friday) ||
				(weekday === 6 && oh.saturday))) continue
			if (duration === 0) {
				const slotStart = dayStart + (oh.start_hour * 60 + oh.start_minute) * 60
				if (now + limitSec <= slotStart) count++
			} else {
				let start_slot = oh.start_hour * 60 + oh.start_minute
				let end_slot = start_slot + duration
				const deadline = oh.end_hour * 60 + oh.end_minute
				while (end_slot + interval <= deadline) {
					const slotStart = dayStart + start_slot * 60
					if (now + limitSec <= slotStart) count++
					start_slot = end_slot + interval
					end_slot = start_slot + duration
				}
			}
		}
		return count
	}

	_remainingStockForDay = (timestamp) => {
		const service_reservations = this.state.service_reservations
		const service_products = this.state.service_products
		if (!service_reservations || !service_products) return null
		const date = new Date(timestamp * 1000)
		const dayStart = Math.round(new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() / 1000)
		const dayEnd = dayStart + 86400
		const soldByProduct = {}
		for (let k = 0; k < service_reservations.length; k++) {
			const r = service_reservations[k]
			if (r.cancelled) continue
			if (r.start >= dayStart && r.start < dayEnd && r.cart && Array.isArray(r.cart)) {
				for (let j = 0; j < r.cart.length; j++) {
					const item = r.cart[j]
					soldByProduct[item._id] = (soldByProduct[item._id] || 0) + Number(item.quantity)
				}
			}
		}
		const remaining = {}
		for (let i = 0; i < service_products.length; i++) {
			const p = service_products[i]
			const stock = Number(p.stock)
			remaining[p._id] = stock === 0 ? 0 : Math.max(0, stock - (soldByProduct[p._id] || 0))
		}
		return remaining
	}

	_findNextAvailableDayCart = () => {
		const service_products = this.state.service_products
		for (let i = 1; i <= 365; i++) {
			const t = this.state.timestamp + i * 86400
			if (!this._hasAvailableSlotCart(t)) continue
			const remaining = this._remainingStockForDay(t)
			const isComplet = remaining && service_products && service_products.length > 0 &&
				service_products.every(p => Number(p.stock) > 0 && (remaining[p._id] || 0) === 0)
			if (!isComplet) return t
		}
		return null
	}

	_getFiveDays = () => {
		const time_assets = this.props.lang_assets.time
		const timestamp = this.state.timestamp
		const times = [
			timestamp - 172800,
			timestamp - 86400,
			timestamp,
			timestamp + 86400,
			timestamp + 172800
		]
		const dates = [
			new Date(times[0] * 1000),
			new Date(times[1] * 1000),
			new Date(times[2] * 1000),
			new Date(times[3] * 1000),
			new Date(times[4] * 1000)
		]
		let days = []
		for (let i = 0; i < 5; i++)
		{
			const month = dates[i].getMonth()
			days[i] = {
				dayNb: dates[i].getDate(),
				dayTxt: time_assets.weekdays_short[dates[i].getDay()] + '.',
				monthNb: month + 1,
				monthTxt: time_assets.months_short[month],
				time: times[i]
			}
			if (days[i].dayNb < 10)
				days[i].dayNb = '0' + days[i].dayNb
			if (days[i].monthNb < 10)
				days[i].monthNb = '0' + days[i].monthNb
		}
		return days
	}

	_checkSlotsAvailable = () => {
		const service_benefit = this.state.service_benefit
		const service_workers = this.state.service_workers
		const service_reservations = this.state.service_reservations
		const lang_assets = this.props.lang_assets.services
		const time_assets = this.props.lang_assets.time
		const days = this._getFiveDays()
		const date = new Date(days[2].time * 1000)
		const year = date.getFullYear()
		const weekday = date.getDay()
		const today = new Date(date.getFullYear(), date.getMonth(), date.getDate())
		let ret = {
			open: false,
			msg: null,
			days: days,
			timestamp: Math.round(today.getTime() / 1000),
			slots: []
		}
		let open = false
		for (let i = 0; i < service_benefit.open_dates.length; i++)
		{
			const open_date = service_benefit.open_dates[i]
			const start = Math.round(new Date(year, open_date.start_month - 1, open_date.start_day).getTime() / 1000)
			const end = Math.round(new Date(year, open_date.end_month - 1, open_date.end_day).getTime() / 1000)
			if (ret.timestamp >= start && ret.timestamp <= end)
			{
				open = true
				break
			}
		}
		if (open === false)
			ret.msg = lang_assets.not_available1
		else
		{
			let open_days = [false, false, false, false, false, false, false]
			for (let i = 0; i < service_benefit.open_hours.length; i++)
			{
				const open_hour = service_benefit.open_hours[i]
				if (open_hour.sunday === true)
					open_days[0] = true
				if (open_hour.monday === true)
					open_days[1] = true
				if (open_hour.tuesday === true)
					open_days[2] = true
				if (open_hour.wednesday === true)
					open_days[3] = true
				if (open_hour.thursday === true)
					open_days[4] = true
				if (open_hour.friday === true)
					open_days[5] = true
				if (open_hour.saturday === true)
					open_days[6] = true
			}
			if (open_days[weekday] === false)
			{
				let daystxt = []
				for (let i = 0; i < time_assets.weekdays.length; i++)
					daystxt.push(time_assets.weekdays[i].toLowerCase())
				const weekdaytxt = daystxt[weekday]
				ret.msg = lang_assets.not_available2 + weekdaytxt
			}
			else
			{
				let workers = []
				for (let i = 0; i < service_workers.length; i++)
				{
					if (service_workers[i].services.length > 0)
					{
						let found = false
						for (let j = 0; j < service_workers[i].services.length; j++)
						{
							if (service_workers[i].services[j] === service_benefit._id)
							{
								found = true
								break
							}
						}
						if (!found)
							continue
					}
					let available = false
					for (let j = 0; j < service_workers[i].working_dates.length; j++)
					{
						const working_date = service_workers[i].working_dates[j]
						const start = Math.round(new Date(year, working_date.start_month - 1, working_date.start_day).getTime() / 1000)
						const end = Math.round(new Date(year, working_date.end_month - 1, working_date.end_day).getTime() / 1000)
						if (ret.timestamp >= start && ret.timestamp <= end)
						{
							available = true
							break
						}
					}
					let working_days = [false, false, false, false, false, false, false]
					for (let j = 0; j < service_workers[i].working_hours.length; j++)
					{
						const open_hour = service_workers[i].working_hours[j]
						if (open_hour.sunday === true)
							working_days[0] = true
						if (open_hour.monday === true)
							working_days[1] = true
						if (open_hour.tuesday === true)
							working_days[2] = true
						if (open_hour.wednesday === true)
							working_days[3] = true
						if (open_hour.thursday === true)
							working_days[4] = true
						if (open_hour.friday === true)
							working_days[5] = true
						if (open_hour.saturday === true)
							working_days[6] = true
					}
					if (working_days[weekday] === false)
						available = false
					if (available === true)
						workers.push(service_workers[i])
				}
				if (workers.length === 0)
					ret.msg = lang_assets.not_available1
				else
				{
					ret.open = true
					let open_hours = []
					for (let i = 0; i < service_benefit.open_hours.length; i++)
					{
						const open_hour = service_benefit.open_hours[i]
						if ((weekday === 0 && open_hour.sunday === true) ||
							(weekday === 1 && open_hour.monday === true) ||
							(weekday === 2 && open_hour.tuesday === true) ||
							(weekday === 3 && open_hour.wednesday === true) ||
							(weekday === 4 && open_hour.thursday === true) ||
							(weekday === 5 && open_hour.friday === true) ||
							(weekday === 6 && open_hour.saturday === true))
						{
							open_hours.push({
								start_hour: open_hour.start_hour,
								start_minute: open_hour.start_minute,
								end_hour: open_hour.end_hour,
								end_minute: open_hour.end_minute
							})
						}
					}
					open_hours.sort((a, b) => {
						const start_time1 = a.start_hour * 60 + a.start_minute
						const start_time2 = b.start_hour * 60 + b.start_minute
						return start_time1 - start_time2
					})
					let i = 1
					while (i < open_hours.length)
					{
						const end_time = open_hours[i - 1].end_hour * 60 + open_hours[i - 1].end_minute
						const start_time = open_hours[i].start_hour * 60 + open_hours[i].start_minute
						if (end_time >= start_time)
						{
							const end_time2 = open_hours[i].end_hour * 60 + open_hours[i].end_minute
							if (end_time2 > end_time)
							{
								const new_slot = {
									start_hour: open_hours[i - 1].start_hour,
									start_minute: open_hours[i - 1].start_minute,
									end_hour: open_hours[i].end_hour,
									end_minute: open_hours[i].end_minute
								}
								open_hours.splice(i - 1, 2, new_slot)
								i = 1
								continue
							}
							else
							{
								const new_slot = {
									start_hour: open_hours[i - 1].start_hour,
									start_minute: open_hours[i - 1].start_minute,
									end_hour: open_hours[i - 1].end_hour,
									end_minute: open_hours[i - 1].end_minute
								}
								open_hours.splice(i - 1, 2, new_slot)
								i = 1
								continue
							}
						}
						i++
					}
					const duration = service_benefit.duration_hour * 60 + service_benefit.duration_minute
					const interval = service_benefit.interval_hour * 60 + service_benefit.interval_minute
					for (let i = 0; i < open_hours.length; i++)
					{
						let start_slot = open_hours[i].start_hour * 60 + open_hours[i].start_minute
						let end_slot = start_slot + duration
						const deadline = open_hours[i].end_hour * 60 + open_hours[i].end_minute
						while (end_slot + interval <= deadline)
						{
							ret.slots.push({
								start: start_slot,
								end: end_slot,
								workers: [],
								reservations: 0
							})
							start_slot = end_slot + interval
							end_slot = start_slot + duration
						}
					}
					for (let i = 0; i < ret.slots.length; i++)
					{
						for (let j = 0; j < workers.length; j++)
						{
							let available = false
							for (let k = 0; k < workers[j].working_hours.length; k++)
							{
								const working_hour = workers[j].working_hours[k]
								if ((weekday === 0 && working_hour.sunday === true) ||
									(weekday === 1 && working_hour.monday === true) ||
									(weekday === 2 && working_hour.tuesday === true) ||
									(weekday === 3 && working_hour.wednesday === true) ||
									(weekday === 4 && working_hour.thursday === true) ||
									(weekday === 5 && working_hour.friday === true) ||
									(weekday === 6 && working_hour.saturday === true))
								{
									const start_time = working_hour.start_hour * 60 + working_hour.start_minute
									const end_time = working_hour.end_hour * 60 + working_hour.end_minute
									if (start_time <= ret.slots[i].start && end_time >= ret.slots[i].end)
									{
										available = true
										break
									}
								}
							}
							if (available === true)
								ret.slots[i].workers.push(workers[j])
						}
					}
					i = 0
					while (i < ret.slots.length)
					{
						if (ret.slots[i].workers.length === 0)
						{
							ret.slots.splice(i, 1)
							continue
						}
						i++
					}
					const nowSeconds = Math.floor(Date.now() / 1000)
					i = 0
					while (i < ret.slots.length)
					{
						const slotStart = ret.slots[i].start * 60 + ret.timestamp
						if (slotStart <= nowSeconds)
						{
							ret.slots.splice(i, 1)
							continue
						}
						i++
					}
					const _service = this.state.service
					const _effectiveLimitEnd = service_benefit.limit_end != null ? Number(service_benefit.limit_end) : (_service && _service.limit_end != null ? Number(_service.limit_end) : 0)
					if (_effectiveLimitEnd > 0)
					{
						for (let i = 0; i < ret.slots.length; i++)
						{
							const slotStart = ret.slots[i].start * 60 + ret.timestamp
							if (nowSeconds + _effectiveLimitEnd * 3600 > slotStart)
								ret.slots[i].not_available = true
						}
					}
					for (let i = 0; i < ret.slots.length; i++)
					{
						const start_time = ret.slots[i].start * 60 + ret.timestamp
						const end_time = ret.slots[i].end * 60 + ret.timestamp
						for (let j = 0; j < ret.slots[i].workers.length; j++)
						{
							for (let k = 0; k < service_reservations.length; k++)
							{
								if (!service_reservations[k].cancelled &&
									service_reservations[k].service_worker === ret.slots[i].workers[j]._id &&
									((service_reservations[k].start <= start_time && service_reservations[k].end > start_time) ||
									(service_reservations[k].start > start_time && service_reservations[k].start < end_time) ||
									(service_reservations[k].end > start_time && service_reservations[k].end < end_time)))
								{
									if (service_reservations[k].self === true)
										ret.slots[i].reservations++
									ret.slots[i].reservations += (service_reservations[k].participants) ? service_reservations[k].participants.length : 0
								}
							}
						}
					}
				}
			}
		}
		return ret
	}

	_checkSlotsAvailableCart = () => {
		const service_benefits = this.state.service_benefits
		const sb = (service_benefits && service_benefits.length > 0) ? service_benefits[0] : null
		const service_reservations = this.state.service_reservations
		if (!sb || !service_reservations) return { open: false, msg: null, days: this._getFiveDays(), timestamp: this._getFiveDays()[2].time, slots: [] }
		const lang_assets = this.props.lang_assets.services
		const time_assets = this.props.lang_assets.time
		const days = this._getFiveDays()
		const date = new Date(days[2].time * 1000)
		const year = date.getFullYear()
		const weekday = date.getDay()
		// const today = new Date(date.getFullYear(), date.getMonth(), date.getDate())
		const now = tools.getTimestamp()
		let ret = {
			open: false,
			msg: null,
			days: days,
			timestamp: days[2].time,
			slots: []
		}
		let open = false
		for (let i = 0; i < sb.open_dates.length; i++)
		{
			const open_date = sb.open_dates[i]
			const start = Math.round(new Date(year, open_date.start_month - 1, open_date.start_day).getTime() / 1000)
			const end = Math.round(new Date(year, open_date.end_month - 1, open_date.end_day).getTime() / 1000)
			if (ret.timestamp >= start && ret.timestamp <= end)
			{
				open = true
				break
			}
		}
		if (open === false)
			ret.msg = lang_assets.not_available1
		else
		{
			let open_days = [false, false, false, false, false, false, false]
			for (let i = 0; i < sb.open_hours.length; i++)
			{
				const open_hour = sb.open_hours[i]
				if (open_hour.sunday === true)
					open_days[0] = true
				if (open_hour.monday === true)
					open_days[1] = true
				if (open_hour.tuesday === true)
					open_days[2] = true
				if (open_hour.wednesday === true)
					open_days[3] = true
				if (open_hour.thursday === true)
					open_days[4] = true
				if (open_hour.friday === true)
					open_days[5] = true
				if (open_hour.saturday === true)
					open_days[6] = true
			}
			if (open_days[weekday] === false)
			{
				let daystxt = []
				for (let i = 0; i < time_assets.weekdays.length; i++)
					daystxt.push(time_assets.weekdays[i].toLowerCase())
				const weekdaytxt = daystxt[weekday]
				ret.msg = lang_assets.not_available2 + weekdaytxt
			}
			else
			{
				ret.open = true
				let open_hours = []
				for (let i = 0; i < sb.open_hours.length; i++)
				{
					const open_hour = sb.open_hours[i]
					if ((weekday === 0 && open_hour.sunday === true) ||
						(weekday === 1 && open_hour.monday === true) ||
						(weekday === 2 && open_hour.tuesday === true) ||
						(weekday === 3 && open_hour.wednesday === true) ||
						(weekday === 4 && open_hour.thursday === true) ||
						(weekday === 5 && open_hour.friday === true) ||
						(weekday === 6 && open_hour.saturday === true))
					{
						open_hours.push({
							start_hour: open_hour.start_hour,
							start_minute: open_hour.start_minute,
							end_hour: open_hour.end_hour,
							end_minute: open_hour.end_minute
						})
					}
				}
				open_hours.sort((a, b) => {
					const start_time1 = a.start_hour * 60 + a.start_minute
					const start_time2 = b.start_hour * 60 + b.start_minute
					return start_time1 - start_time2
				})

				// on fusionne les créneaux horaires qui se chevauchent
				let i = 1
				while (i < open_hours.length)
				{
					const end_time = open_hours[i - 1].end_hour * 60 + open_hours[i - 1].end_minute
					const start_time = open_hours[i].start_hour * 60 + open_hours[i].start_minute
					if (end_time >= start_time)
					{
						const end_time2 = open_hours[i].end_hour * 60 + open_hours[i].end_minute
						if (end_time2 > end_time)
						{
							const new_slot = {
								start_hour: open_hours[i - 1].start_hour,
								start_minute: open_hours[i - 1].start_minute,
								end_hour: open_hours[i].end_hour,
								end_minute: open_hours[i].end_minute
							}
							open_hours.splice(i - 1, 2, new_slot)
							i = 1
							continue
						}
						else
						{
							const new_slot = {
								start_hour: open_hours[i - 1].start_hour,
								start_minute: open_hours[i - 1].start_minute,
								end_hour: open_hours[i - 1].end_hour,
								end_minute: open_hours[i - 1].end_minute
							}
							open_hours.splice(i - 1, 2, new_slot)
							i = 1
							continue
						}
					}
					i++
				}

				// création des slots
				const duration = sb.duration_hour * 60 + sb.duration_minute
				const interval = sb.interval_hour * 60 + sb.interval_minute
				const limitSec = (sb.limit_end != null ? Number(sb.limit_end) : 0) * 3600
				for (let i = 0; i < open_hours.length; i++)
				{
					if (duration === 0)
					{
						// full window = 1 slot per open_hours range
						const start_slot = Number(open_hours[i].start_hour * 60) + Number(open_hours[i].start_minute)
						const end_slot = Number(open_hours[i].end_hour * 60) + Number(open_hours[i].end_minute)
						const start_time = this.state.timestamp + (start_slot * 60)
						ret.slots.push({
							start: start_slot,
							end: end_slot,
							reservations: 0,
							not_available: now + limitSec > start_time
						})
					}
					else
					{
						let start_slot = Number(open_hours[i].start_hour * 60) + Number(open_hours[i].start_minute)
						let end_slot = start_slot + duration
						const deadline = Number(open_hours[i].end_hour * 60) + Number(open_hours[i].end_minute)
						while (end_slot + interval <= deadline)
						{
							const start_time = this.state.timestamp + (start_slot * 60)
							ret.slots.push({
								start: start_slot,
								end: end_slot,
								reservations: 0,
								not_available: now + limitSec > start_time
							})
							start_slot = Number(end_slot + interval)
							end_slot = Number(start_slot + duration)
						}
					}
				}
				for (let i = 0; i < ret.slots.length; i++)
				{
					const start_time = ret.slots[i].start * 60 + ret.timestamp
					const end_time = ret.slots[i].end * 60 + ret.timestamp
					if (ret.slots[i])
					for (let k = 0; k < service_reservations.length; k++)
					{
						if ((service_reservations[k].start <= start_time && service_reservations[k].end > start_time) ||
							(service_reservations[k].start > start_time && service_reservations[k].start < end_time) ||
							(service_reservations[k].end > start_time && service_reservations[k].end < end_time))
						{
							ret.slots[i].reservations++
						}
					}
				}
			}
		}
		return ret
	}

	selectBenefit = (_id) => {
		this.setState(prev => ({
			selectedBenefitId: prev.selectedBenefitId === _id ? null : _id
		}))
	}

	bookService = (id) => {
		const u = this.props.user
		if (!u || u.invite === true)
		{
			sessionStorage.setItem('pending_benefit_id', this.state.selectedBenefitId || id)
			this.setState({ authSheet: true })
			return
		}
		let service_benefit = null
		const service_benefits = this.state.service_benefits
		for (let i = 0; i < service_benefits.length; i++)
		{
			if (service_benefits[i]._id === id)
			{
				service_benefit = service_benefits[i]
				break
			}
		}
		this.setState({ service_benefit: service_benefit, step: 1 })
	}

	printServiceBenefit = (_id, icon, duration_hour, duration_minute, show_price, price, translations, key) => {
		const lang_assets = this.props.lang_assets.services
		let prev = null
		const icons = this.props.icons
		const theme = this.props.theme
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === icon)
			{
				prev = icons[i]
				break
			}
		}
		let duration = null
		if (duration_hour > 0)
			duration = duration_hour + 'h'
		if (duration_minute > 0)
		{
			if (duration === null)
				duration = duration_minute + 'm'
			else
				duration += duration_minute
		}
		const benefitTr = tools.mergeTranslation(translations, this.props.user.lang)
		let subtitle = benefitTr.subtitle || ""
		let description = benefitTr.description || ""
		let location = benefitTr.location || ""
		const alt = "picto " + subtitle
		const pictoJSX = (prev !== null) ? <ThemeIcon icon={prev} type="fill" color={'#' + theme.color1} legacyTheme={theme._id} alt={alt} className="benefit-list__picto" /> : null
		const tarif = (price > 0) ? price + '€' : lang_assets.free
		const themeColor = '#' + this.props.theme.color1
		const isSelected = this.state.selectedBenefitId === _id
		const btnStyle = isSelected
			? { backgroundColor: themeColor, borderColor: themeColor, color: '#ffffff', width: 36, height: 36, minWidth: 36, padding: 0, marginTop: 2 }
			: { backgroundColor: '#f3f4f6', borderColor: '#e5e7eb', color: '#9ca3af', width: 36, height: 36, minWidth: 36, padding: 0, marginTop: 2 }
		return (
			<div className="benefit-list__item" key={key}>
				<div className="benefit-list__row">
					<div className="benefit-list__body">
						{pictoJSX ? <div className="benefit-list__icon">{pictoJSX}</div> : null}
						<div className="benefit-list__text">
							<h3 className="benefit-list__title">{subtitle}</h3>
							{(duration || location) ? (
								<p className="benefit-list__meta">
									{duration ? <span>{duration}</span> : null}
									{duration && location ? <span> · </span> : null}
									{location ? <span>{location}</span> : null}
								</p>
							) : null}
							{description ? <div className="benefit-list__desc" dangerouslySetInnerHTML={{ __html: description }} /> : null}
							{price > 0 ? <p className="benefit-list__price">{tarif}</p> : null}
						</div>
					</div>
					<button
						type="button"
						className="benefit-list__btn"
						style={btnStyle}
						onClick={() => this.selectBenefit(_id)}
					>
						{isSelected ? '✓' : '+'}
					</button>
				</div>
			</div>
		)
	}

	handleQuantity = (id, e) => {
		const service_products = this.state.service_products
		for (let i = 0; i < service_products.length; i++)
		{
			if (service_products[i]._id === id)
			{
				service_products[i].quantity = e.target.value
				break
			}
		}
		this.setState({ service_products: service_products })
	}

	changeQuantity = (id, delta) => {
		const service_products = this.state.service_products.map(p => {
			if (p._id !== id) return p
			const stockNum = Number(p.stock)
			const current = Number(p.quantity) || 0
			const max = stockNum > 0 ? stockNum : 9999
			return { ...p, quantity: Math.min(max, Math.max(0, current + delta)) }
		})
		this.setState({ service_products })
	}

	_addProduct = (id) => {
		let service_product = null
		const service_products = this.state.service_products
		for (let i = 0; i < service_products.length; i++)
		{
			if (service_products[i]._id === id)
			{

				service_product = service_products[i]
				break
			}
		}
		this.setState({ service_benefit: service_product, step: 1 })
	
	}

	printServiceProduct = (_id, icon, stock, price, quantity, translations, service, key) => {
		const lang_assets = this.props.lang_assets.services
		let jsx = null
		let prev = null
		const icons = this.props.icons
		const theme = this.props.theme
		for (let i = 0; i < icons.length; i++)
		{
			if (icons[i]._id === icon)
			{
				prev = icons[i]
				break
			}
		}
		let location = ""
		for (let i = 0; i < service.translations.length; i++)
		{
			if (service.translations[i].lang === this.props.user.lang)
			{
				location = service.translations[i].location
				break
			}
		}
		const benefitTr = tools.mergeTranslation(translations, this.props.user.lang)
		let subtitle = benefitTr.subtitle || ""
		let description = benefitTr.description || ""
		const alt = "picto " + subtitle
		const pictoJSX = (prev !== null) ? <ThemeIcon icon={prev} type="fill" color={'#' + theme.color1} legacyTheme={theme._id} alt={alt} className="picto" /> : null
		let price_txt = String(price)
		if (price > 0)
		{
			let price_tab = String(price).split('.')
			if (price_tab.length > 1)
			{
				if (price_tab[1].length === 1)
					price_tab[1] += '0'
				else if (price_tab[1].length > 2)
					price_tab[1] = price_tab[1].substring(0, 2)
				price_txt = price_tab[0] + ',' + price_tab[1]
			}
		}
		const tarif = (price > 0) ? price_txt + '€' : lang_assets.free
		jsx = (
			<div className="service" key={key}>
				<p className="title">
					{pictoJSX}
					{subtitle}
				</p>
				<p className="location">{lang_assets.location}: {location}</p>
				<div className="wysiwyg" dangerouslySetInnerHTML={{ __html: description }}></div>
				<p className="price">{lang_assets.price}: <span className="text">{tarif}</span></p>
				<label className="quantity">
					{lang_assets.quantity} : <input type="number" value={quantity} onChange={this.handleQuantity.bind(this, _id)} min="0" max={stock} />
				</label>
			</div>
		)
		return (jsx)
	}

	cartCheckout = (e) => {
		if (e && e.preventDefault) e.preventDefault()
		const u = this.props.user
		if (!u || u.invite === true) {
			this.setState({ authSheet: true })
			return
		}
		const service_products = this.state.service_products
		let cart = []
		if (service_products && service_products.length > 0)
		{
			for (let i = 0; i < service_products.length; i++)
			{
				if (service_products[i].quantity > 0)
					cart.push(service_products[i])
			}
		}
		if (cart.length > 0)
			this.setState({ step: 2, cart: cart, error: null })
		else
			this.setState({ error: this.props.lang_assets.services.error_cart })
	}

	render() {
		const service = this.state.service
		const service_benefits = this.state.service_benefits
		const service_benefit = this.state.service_benefit
		const service_products = this.state.service_products
		const lang_assets = this.props.lang_assets.services
		const themeColor = '#' + this.props.theme.color1
		const authSheet = this.state.authSheet
		if (authSheet)
		{
			const redirect = encodeURIComponent(this.props.history.location.pathname)
			return (
				<div>
					<div
						style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)', zIndex: 50 }}
						onClick={() => this.setState({ authSheet: false })}
					/>
					<div style={{
						position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 51,
						backgroundColor: '#ffffff', borderRadius: '24px 24px 0 0',
						padding: '12px 24px 0',
					paddingBottom: 'calc(10vh + max(20px, env(safe-area-inset-bottom, 0px)))',
						animation: 'slideUp 0.32s cubic-bezier(0.32, 0.72, 0, 1)'
					}}>
						<div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
							<div style={{ width: 36, height: 4, borderRadius: 2, backgroundColor: '#e5e7eb' }} />
						</div>
						<h2 className="text-xl font-bold text-gray-900 mb-1">Connectez-vous pour continuer</h2>
						<p className="text-sm text-gray-500 mb-6">Vous avez une réservation de séjour ? Créez votre compte avec l’email ou le code d’activation reçu lors de votre réservation.</p>
						<Link
							to={`/connexion?redirect=${redirect}`}
							className="block w-full py-4 rounded-full text-white font-semibold text-base text-center mb-3"
							style={{ backgroundColor: themeColor }}
						>
							Se connecter
						</Link>
						<Link
							to={`/inscription?redirect=${redirect}`}
							className="block w-full py-3 rounded-full text-center font-semibold text-base border-2"
							style={{ color: themeColor, borderColor: themeColor }}
						>
							Créer mon compte
						</Link>
						<button
							type="button"
							onClick={() => this.setState({ authSheet: false })}
							className="block w-full py-3 mt-1 text-gray-400 text-sm font-medium text-center"
						>
							Annuler
						</button>
					</div>
				</div>
			)
		}
		if (service && service.type === "prestation" && service_benefits && this.props.icons)
		{
			if (this.state.step === 0)
			{
				// afficher les différentes prestations
				let image = (this.state.service.cover) ? connexion.connect.url + 'dashboard/services/cover?id=' + this.state.service._id : null
				if (image === null)
					image = picture
				let pictureJSX = null
				if (image)
				{
					pictureJSX = (
						<div className="photoWrap">
							<img src={image} alt="banner" />
						</div>
					)
				}
				let service_benefit_k = -1
				const themeColorStep0 = '#' + this.props.theme.color1
				const selId = this.state.selectedBenefitId
				const selBenefit = selId ? service_benefits.find(b => b._id === selId) : null
				let selSubtitle = ''
				let selTarifLabel = null
				if (selBenefit)
				{
					const selTr = tools.mergeTranslation(selBenefit.translations, this.props.user.lang)
					selSubtitle = selTr.subtitle || ''
					if (selBenefit.price > 0)
						selTarifLabel = selBenefit.price + '€'
				}
				return (
					<div>
						{pictureJSX}
						<div className="contentWrapper">
							<div className="benefit-list">
								{
									service_benefits.map(({ _id, icon, duration_hour, duration_minute, show_price, price, translations }) => {
										service_benefit_k++
										let ret = this.printServiceBenefit(_id, icon, duration_hour, duration_minute, show_price, price, translations, service_benefit_k)
										return (ret)
									})
								}
							</div>
						</div>
						{selBenefit && (
							<div className="slot-confirm-bar">
								<div className="slot-confirm-bar__info">
									<span className="slot-confirm-bar__date">{selSubtitle}</span>
									{selTarifLabel ? <span className="slot-confirm-bar__time">{selTarifLabel}</span> : null}
								</div>
								<button
									className="slot-confirm-bar__btn"
									style={{ backgroundColor: themeColorStep0 }}
									onClick={() => this.bookService(selId)}
								>
									{lang_assets.continue || 'Continuer'} →
								</button>
							</div>
						)}
					</div>
				)
			}
			else if (this.state.step === 1 && service_benefit)
			{
				// afficher les slots disponibles
				let slotsJSX = null
				const checkSlotsAvailable = this._checkSlotsAvailable()
				const nextAvailableDay = this._findNextAvailableDay()
				const time_assets = this.props.lang_assets.time
				let nextAvailableBtn = null
				if (nextAvailableDay) {
					const d = new Date(nextAvailableDay * 1000)
					const dayNb = d.getDate()
					const monthTxt = time_assets.months_short[d.getMonth()]
					nextAvailableBtn = (
						<div className="next-open-wrapper">
							<p className="next-open-info">
								{lang_assets.next_available_from} {dayNb} {monthTxt}
							</p>
							<button className="next-available-btn" onClick={() => this.updateTime(nextAvailableDay)}>
								{lang_assets.next_available}
							</button>
						</div>
					)
				}
				const dh = service_benefit.duration_hour
				const dm = service_benefit.duration_minute
				const durationLabel = dh > 0 && dm > 0 ? `${dh}h${dm}` : dh > 0 ? `${dh}h` : `${dm}min`
				if (checkSlotsAvailable.open === false)
				{
					slotsJSX = (
						<div className="slots">
							<p className="unavailable">{checkSlotsAvailable.msg}</p>
							{nextAvailableBtn}
						</div>
					)
				}
				else
				{
					let slot_k = -1
					const simultaneous = service_benefit.simultaneous
					const themeColor = '#' + this.props.theme.color1
					slotsJSX = (
						<div className="slots">
							<div className="slots-grid">
								{checkSlotsAvailable.slots.map(({ start, end, workers, reservations, not_available }) => {
									slot_k++
									let start_hour = Math.floor(start / 60)
									if (start_hour < 10)
										start_hour = '0' + start_hour
									let start_minute = start - (start_hour * 60)
									if (start_minute < 10)
										start_minute = '0' + start_minute
									const max = workers.length * simultaneous
									const isFull = simultaneous !== null && reservations >= max
									const isDisabled = isFull || not_available === true
									const available = max - reservations
									const isFew = !isDisabled && available > 0 && ((max >= 6 && available < 3) || (max >= 4 && available < 2))
									const action = isDisabled ? null : this.selectSlot.bind(this, checkSlotsAvailable.timestamp, start, end, workers)
									const isSelected = !isDisabled && this.state.selectedSlot && this.state.selectedSlot.day === checkSlotsAvailable.timestamp && this.state.selectedSlot.start === start
									let pillClass = 'slot-pill'
									if (isDisabled) pillClass += ' slot-pill--full'
									else if (isSelected) pillClass += ' slot-pill--selected'
									else if (isFew) pillClass += ' slot-pill--few'
									const pillStyle = isFull ? {} : isSelected ? { backgroundColor: themeColor, borderColor: themeColor } : { borderColor: themeColor }
									const fewLabel = isFew
										? (available === 1 ? `1 ${lang_assets.one_slot}` : `${available} ${lang_assets.two_slots}`)
										: null
									return (
										<div className={pillClass} style={pillStyle} key={slot_k} onClick={action}>
											{isFew && <span className="slot-pill__badge">{fewLabel}</span>}
											<span className="slot-pill__time">{start_hour}:{start_minute}</span>
											{isDisabled
												? <span className="slot-pill__full">{not_available ? (lang_assets.registration_closed || 'Fermé') : lang_assets.full}</span>
												: <span className="slot-pill__end">{durationLabel}</span>
											}
										</div>
									)
								})}
							</div>
							{nextAvailableBtn}
						</div>
					)
				}
				let day_k = -1
				return (
					<div className="Dates">
						<div className="header" style={{ backgroundColor: '#' + this.props.theme.color1 }}>
							<h1>{lang_assets.title}</h1>
							<div className="days">
								{checkSlotsAvailable.days.map(({ dayNb, dayTxt, monthTxt, time }) => {
									day_k++
									const todayMidnight = Math.round(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0).getTime() / 1000)
									const isPast = time < todayMidnight
									let classname = "day"
									if (day_k === 0)
										classname += ' first'
									else if (day_k === 2)
										classname += ' select'
									if (isPast)
										classname += ' past'
									const isSelected = day_k === 2
									const hasDispo = this._hasAvailableSlot(time)
									const dot = hasDispo ? (
										<span className="day-dot" style={isSelected ? { backgroundColor: '#' + this.props.theme.color1 } : {}} />
									) : null
									if (!isSelected)
									{
										return (
											<div className={classname} key={day_k} onClick={isPast ? undefined : this.updateTime.bind(this, time)}>
												<p>
													<span className="day-txt">{dayTxt}</span>
													<strong>{dayNb}</strong><br />
													{monthTxt}
												</p>
												{dot}
											</div>
										)
									}
									else
									{
										return (
											<div className={classname} key={day_k}>
												<p>
													<span className="day-txt">{dayTxt}</span>
													<strong>{dayNb}</strong><br />
													{monthTxt}
												</p>
												{dot}
											</div>
										)
									}
								})}
							</div>
							<div style={{ clear: 'both' }}></div>
						</div>
						{slotsJSX}
					{(() => {
						const sel = this.state.selectedSlot
						if (!sel) return null
						const time_assets = this.props.lang_assets.time
						const selDate = new Date(sel.day * 1000)
						const dayName = time_assets.weekdays_short[selDate.getDay()]
						const dayNum = selDate.getDate()
						const monthName = time_assets.months_short[selDate.getMonth()]
						let sh = Math.floor(sel.start / 60)
						if (sh < 10) sh = '0' + sh
						let sm = sel.start % 60
						if (sm < 10) sm = '0' + sm
						return (
							<div className="slot-confirm-bar">
								<div className="slot-confirm-bar__info">
									<span className="slot-confirm-bar__date">{dayName}. {dayNum} {monthName}</span>
									<span className="slot-confirm-bar__time">{sh}:{sm} &middot; {durationLabel}</span>
								</div>
								<button className="slot-confirm-bar__btn" style={{ backgroundColor: '#' + this.props.theme.color1 }} onClick={this.confirmSlot}>
									{lang_assets.book} →
								</button>
							</div>
						)
					})()} 
					</div>
				)
			}
			else if (this.state.step === 2)
			{
				return (
					<Booking
						pathname={this.props.history.location.pathname}
						user={this.props.user}
						updateShell={this.props.updateShell}
						updateCustomBack={this.props.updateCustomBack}
						updateLogs={this.props.updateLogs}
						reservation={this.state.reservation}
						service_benefit={this.state.service_benefit}
						theme={this.props.theme}
						lang_assets={this.props.lang_assets}
						postServiceReservation={this.props.postServiceReservation}
						createBenefitPaymentIntent={this.props.createBenefitPaymentIntent}
						fetchServiceByID={this.props.fetchServiceByID}
						postUpdateBirthday={this.props.postUpdateBirthday}
						postUpdatePhone={this.props.postUpdatePhone}
						onEditCart={() => this.setState({ step: 0 })}
					/>
				)
			}
		}
		else if (service && service.type === "vente" && service_products && this.props.icons)
		{
			if (this.state.step === 1)
			{
				// afficher les produits disponibles
				const image = (service.cover) ? connexion.connect.url + 'dashboard/services/cover?id=' + service._id : null
				let cartCount = 0
				let cartTotal = 0
				service_products.forEach(p => {
					const qty = Number(p.quantity) || 0
					cartCount += qty
					cartTotal += qty * Number(p.price)
				})
				const cartHasItems = cartCount > 0
				const selectedTs = this.state.selectedSlotCart ? this.state.selectedSlotCart.day : null
				const remainingStock = selectedTs ? this._remainingStockForDay(selectedTs) : null
				return (
					<div>
						{image && (
							<div className="photoWrap">
								<img src={image} alt="banner" />
							</div>
						)}
						<div className="contentWrapper has-sticky-cta">
							<div className="px-5 pt-7">
								{this.state.reservation && (() => {
									const resStart = new Date(this.state.reservation.start * 1000)
									const time_assets_local = this.props.lang_assets.time
									const wdays = time_assets_local.weekdays_short
									const mons = time_assets_local.months_short
									let rHour = resStart.getHours(); if (rHour < 10) rHour = '0' + rHour
									let rMin = resStart.getMinutes(); if (rMin < 10) rMin = '0' + rMin
									return (
										<div className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-2xl px-4 py-2 mb-4">
											<div>
												<p className="text-xs font-medium text-gray-400 uppercase tracking-wide" style={{ margin: 0 }}>{lang_assets.your_slot}</p>
												<p className="text-base font-bold text-gray-900" style={{ margin: 0 }}>{wdays[resStart.getDay()]} {resStart.getDate()} {mons[resStart.getMonth()]} · {rHour}h{rMin}</p>
											</div>
											<button type="button" onClick={() => this.setState({ step: 0 })}
												style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, width: 36, height: 36 }}>
												<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
													<rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
													<line x1="16" y1="2" x2="16" y2="6"/>
													<line x1="8" y1="2" x2="8" y2="6"/>
													<line x1="3" y1="10" x2="21" y2="10"/>
												</svg>
											</button>
										</div>
									)
								})()}
								<h1 className="text-xl font-bold text-gray-900 mb-2">{service.name}</h1>
								{(() => {
									const families = service.families || []
									if (families.length < 1) return null
									const hasUncategorized = service_products.some(p => !p.family || !families.find(f => f.id === p.family))
									const lang = this.props.user ? this.props.user.lang : 'fr'
									const getFamilyName = (f) => {
										const t = (f.translations || []).find(t => t.lang === lang)
										return (t && t.name) ? t.name : ((f.translations || [])[0] || {}).name || ''
									}
									const pillStyle = (active) => ({
										display: 'inline-block',
										padding: '6px 16px',
										borderRadius: 9999,
										fontSize: 14,
										fontWeight: active ? 600 : 400,
										color: active ? '#111827' : '#6b7280',
										background: active ? '#f3f4f6' : 'white',
										border: '1px solid',
										borderColor: active ? '#d1d5db' : '#e5e7eb',
										cursor: 'pointer',
										flexShrink: 0,
										transition: 'all 0.15s',
										WebkitTapHighlightColor: 'transparent'
									})
									return (
										<div style={{ display: 'flex', overflowX: 'auto', gap: 8, paddingBottom: 4, marginBottom: 12, WebkitOverflowScrolling: 'touch' }}>
											<span onClick={() => this.setState({ selectedFamily: null })} style={pillStyle(this.state.selectedFamily === null)}>Tous</span>
											{families.map(f => (
												<span key={f.id} onClick={() => this.setState({ selectedFamily: f.id })} style={pillStyle(this.state.selectedFamily === f.id)}>{getFamilyName(f)}</span>
											))}
											{hasUncategorized && (
												<span onClick={() => this.setState({ selectedFamily: '__autres__' })} style={pillStyle(this.state.selectedFamily === '__autres__')}>Autres</span>
											)}
										</div>
									)
								})()}
								{(() => {
									const families = service.families || []
									const selectedFamily = this.state.selectedFamily
									const filtered = selectedFamily === null
										? service_products
										: selectedFamily === '__autres__'
											? service_products.filter(p => !p.family || !families.find(f => f.id === p.family))
											: service_products.filter(p => p.family === selectedFamily)
									return filtered.map(({ _id, stock, price, quantity, translations, image }) => {
									let name = ''
									let description = ''
									for (let i = 0; i < translations.length; i++) {
										if (translations[i].lang === this.props.user.lang) {
											name = translations[i].title || translations[i].subtitle || ''
											description = translations[i].description || ''
											break
										}
									}
									if (!name && translations.length > 0)
										name = translations[0].title || translations[0].subtitle || ''
									const qty = Number(quantity) || 0
									const stockNum = Number(stock)
									const effectiveStock = remainingStock ? (remainingStock[_id] !== undefined ? remainingStock[_id] : stockNum) : stockNum
									const priceFmt = Number(price) > 0 ? Number(price).toFixed(2).replace('.', ',') + '€' : lang_assets.free
									const canInc = effectiveStock === 0 || qty < effectiveStock
									const canDec = qty > 0
									const showImage = service.product_images && image
									const descriptionText = description
										? description.replace(/<[^>]*>/g, '').slice(0, 120) + (description.replace(/<[^>]*>/g, '').length > 120 ? '…' : '')
										: ''
									return (
										<div key={_id} className="flex items-start gap-3 py-4 product-row-separator">
											{showImage && (
												<img
													src={connexion.connect.url + 'dashboard/files/get-image/' + image + '/200'}
													alt={name}
													style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 10, flexShrink: 0 }}
												/>
											)}
											<div className="flex-1" style={{ minWidth: 0 }}>
												<div className="text-base font-semibold text-gray-900">{name}</div>
												{descriptionText ? <div className="text-sm mt-0.5" style={{ color: '#9ca3af' }}>{descriptionText}</div> : null}
												<div className="text-sm font-medium mt-1" style={{ color: qty > 0 ? themeColor : '#6b7280' }}>{priceFmt}</div>
												{effectiveStock > 0 && effectiveStock <= 3 ? <div className="text-xs font-medium mt-1" style={{ color: '#f59e0b' }}>{(effectiveStock > 1 ? lang_assets.stock_few_plural : lang_assets.stock_few).replace('{n}', effectiveStock)}</div> : null}
											</div>
											<div className="flex items-center flex-shrink-0 rounded-full bg-gray-100" style={{ height: 36, alignSelf: 'center' }}>
												<span
													onClick={canDec ? () => this.changeQuantity(_id, -1) : undefined}
													style={{ width: 36, height: 36, opacity: canDec ? 1 : 0.25, pointerEvents: canDec ? 'auto' : 'none', color: '#374151', fontSize: 18, fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: 'none' }}>
													−
												</span>
												<span style={{ minWidth: 20, textAlign: 'center', fontSize: 15, fontWeight: 600, color: '#111827' }}>{qty}</span>
												<span
													onClick={canInc ? () => this.changeQuantity(_id, 1) : undefined}
													style={{ width: 36, height: 36, pointerEvents: canInc ? 'auto' : 'none', color: canInc ? themeColor : '#d1d5db', fontSize: 18, fontWeight: 600, cursor: canInc ? 'pointer' : 'default', display: 'flex', alignItems: 'center', justifyContent: 'center', userSelect: 'none' }}>
													+
												</span>
											</div>
										</div>
									)
								})
								})()}
								{this.state.error && <p className="text-sm text-red-500 mt-3">{this.state.error}</p>}
							</div>
						</div>
						{/* Sticky CTA */}
						<div className="sticky-cta-bar">
							{cartHasItems && (
								<div className="flex items-center justify-between mb-3 px-1">
									<span className="text-sm text-gray-500">{cartCount} {cartCount > 1 ? lang_assets.article_many : lang_assets.article_one}</span>
									<span className="text-sm font-bold text-gray-900">{cartTotal.toFixed(2).replace('.', ',')}€</span>
								</div>
							)}
							<button type="button"
								onClick={cartHasItems ? this.cartCheckout : undefined}
								disabled={!cartHasItems}
								className="service-cta-btn waves-effect waves-light disabled:opacity-40"
								style={{ backgroundColor: themeColor }}>
								{lang_assets.validate_order}
							</button>
						</div>
					</div>
				)
			}
			else if (this.state.step === 0)
			{
				const now = new Date()
				const todayMidnight = Math.round(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0).getTime() / 1000)
				const tomorrowMidnight = todayMidnight + 86400
				const todayHasSlots = this._hasAvailableSlotCart(todayMidnight)
				const tomorrowHasSlots = this._hasAvailableSlotCart(tomorrowMidnight)
				const todayCount = this._countSlotsForDay(todayMidnight)
				const tomorrowCount = this._countSlotsForDay(tomorrowMidnight)
				const { selectedDayCard, selectedSlotCart } = this.state
				const time_assets = this.props.lang_assets.time
				const remainingToday = this._remainingStockForDay(todayMidnight)
				const remainingTomorrow = this._remainingStockForDay(tomorrowMidnight)
				const _isComplet = (remaining) => remaining && service_products && service_products.length > 0 &&
					service_products.every(p => Number(p.stock) > 0 && (remaining[p._id] || 0) === 0)
				const todayIsComplet = todayHasSlots && _isComplet(remainingToday)
				const tomorrowIsComplet = tomorrowHasSlots && _isComplet(remainingTomorrow)
				const showPlanning = selectedDayCard === 'other' || (!todayHasSlots && !tomorrowHasSlots)
				const canGoBackToCards = todayHasSlots || tomorrowHasSlots

				// Slots pour le jour sélectionné (utilisé inline ou dans le planning)
				const checkSlotsAvailable = this._checkSlotsAvailableCart()
				const nextAvailableDayCart = this._findNextAvailableDayCart()
				let nextAvailableBtnCart = null
				if (nextAvailableDayCart) {
					const d = new Date(nextAvailableDayCart * 1000)
					const dayNb = d.getDate()
					const monthTxt = time_assets.months_short[d.getMonth()]
					nextAvailableBtnCart = (
						<div className="next-open-wrapper">
							<p className="next-open-info">
								{lang_assets.next_available_from} {dayNb} {monthTxt}
							</p>
							<button className="next-available-btn" style={{ color: themeColor }} onClick={() => { this.updateTime(nextAvailableDayCart); this.setState({ selectedSlotCart: null }) }}>
								{lang_assets.next_available}
							</button>
						</div>
					)
				}

				// Rendu des slots (réutilisé inline et dans le planning)
				const renderSlots = (withNextBtn) => {
					if (!checkSlotsAvailable.open) return <p className="unavailable px-4">{checkSlotsAvailable.msg}</p>
					const remainingForDay = this._remainingStockForDay(checkSlotsAvailable.timestamp)
					if (_isComplet(remainingForDay)) return (
						<>
							<p className="unavailable">{lang_assets.full}</p>
							{withNextBtn && nextAvailableBtnCart}
						</>
					)
					const slots = checkSlotsAvailable.slots
					if (slots.length === 0) return null
					const slotItems = slots.length === 1 ? (() => {
						const { start, end, not_available } = slots[0]
						let sh = Math.floor(start / 60); if (sh < 10) sh = '0' + sh
						let sm = start - Math.floor(start / 60) * 60; if (sm < 10) sm = '0' + sm
						let eh = Math.floor(end / 60); if (eh < 10) eh = '0' + eh
						let em = end - Math.floor(end / 60) * 60; if (em < 10) em = '0' + em
						const isSelected = selectedSlotCart && selectedSlotCart.start === start && selectedSlotCart.day === checkSlotsAvailable.timestamp
						let soloClass = 'slot-solo'
						if (not_available) soloClass += ' slot-solo--full'
						else if (isSelected) soloClass += ' slot-solo--selected'
						const soloStyle = isSelected ? { backgroundColor: themeColor, borderColor: themeColor } : not_available ? {} : { borderColor: themeColor }
						return (
							<div className={soloClass} style={soloStyle}
								onClick={not_available ? undefined : () => this.selectSlotCartPreview(checkSlotsAvailable.timestamp, start, end)}>
								<div className="slot-solo__left">
									<span className="slot-solo__time">{sh}:{sm} → {eh}:{em}</span>
									{not_available && <span className="slot-solo__closed">{lang_assets.registration_closed}</span>}
								</div>
								<div className="slot-solo__check" style={isSelected ? { borderColor: 'white' } : not_available ? { borderColor: '#d1d5db' } : { borderColor: themeColor }}>
									{isSelected && <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M2 7l4 4 6-6" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>}
								</div>
							</div>
						)
					})() : (
						<div className="slots-grid">
							{slots.map(({ start, end, not_available }, slot_k) => {
								let sh = Math.floor(start / 60); if (sh < 10) sh = '0' + sh
								let sm = start - Math.floor(start / 60) * 60; if (sm < 10) sm = '0' + sm
								let eh = Math.floor(end / 60); if (eh < 10) eh = '0' + eh
								let em = end - Math.floor(end / 60) * 60; if (em < 10) em = '0' + em
								const isSelected = selectedSlotCart && selectedSlotCart.start === start && selectedSlotCart.day === checkSlotsAvailable.timestamp
								let pillClass = 'slot-pill'
								if (not_available) pillClass += ' slot-pill--full'
								else if (isSelected) pillClass += ' slot-pill--selected'
								const pillStyle = isSelected ? { backgroundColor: themeColor, borderColor: themeColor } : not_available ? {} : { borderColor: themeColor }
								return (
									<div key={slot_k} className={pillClass} style={pillStyle}
										onClick={not_available ? undefined : () => this.selectSlotCartPreview(checkSlotsAvailable.timestamp, start, end)}>
										<span className="slot-pill__time">{sh}:{sm}</span>
										<span className="slot-pill__end">{eh}:{em}</span>
										{not_available && <span className="slot-pill__full">{lang_assets.registration_closed}</span>}
									</div>
								)
							})}
						</div>
					)
					return <>{slotItems}{withNextBtn && nextAvailableBtnCart}</>
				}

				// Barre de confirmation sticky (commune aux deux vues)
				const confirmBarJSX = selectedSlotCart ? (() => {
					const selDate = new Date(selectedSlotCart.day * 1000)
					const dayName = time_assets.weekdays_short[selDate.getDay()]
					const dayNum = selDate.getDate()
					const monthName = time_assets.months_short[selDate.getMonth()]
					let sh = Math.floor(selectedSlotCart.start / 60); if (sh < 10) sh = '0' + sh
					let sm = selectedSlotCart.start - Math.floor(selectedSlotCart.start / 60) * 60; if (sm < 10) sm = '0' + sm
					let eh = Math.floor(selectedSlotCart.end / 60); if (eh < 10) eh = '0' + eh
					let em = selectedSlotCart.end - Math.floor(selectedSlotCart.end / 60) * 60; if (em < 10) em = '0' + em
					return (
						<div className="slot-confirm-bar">
							<div className="slot-confirm-bar__info">
								<span className="slot-confirm-bar__date">{dayName}. {dayNum} {monthName}</span>
								<span className="slot-confirm-bar__time">{sh}:{sm} – {eh}:{em}</span>
							</div>
							<button className="slot-confirm-bar__btn" style={{ backgroundColor: themeColor }} onClick={this.confirmSlotCart}>
								{lang_assets.confirm_slot} →
							</button>
						</div>
					)
				})() : null

				// Vue planning (existante)
				if (showPlanning) {
					let day_k = -1
					return (
						<div className="Dates" style={{ backgroundColor: '#' + this.props.theme.color1 }}>
							{canGoBackToCards && (
								<button type="button"
									onClick={() => this.setState({ selectedDayCard: null, selectedSlotCart: null, timestamp: todayMidnight })}
									className="flex items-center gap-1 px-4 pt-3 pb-1 text-sm font-medium"
									style={{ color: 'rgba(255,255,255,0.8)' }}>
									← Retour
								</button>
							)}
							<div className="header" style={{ backgroundColor: '#' + this.props.theme.color1 }}>
								<h1>{lang_assets.title}</h1>
								<div className="days">
									{checkSlotsAvailable.days.map(({ dayNb, dayTxt, monthTxt, time }) => {
										day_k++
										const isPast = time < todayMidnight
										let classname = "day"
										if (day_k === 0) classname += ' first'
										else if (day_k === 2) classname += ' select'
										if (isPast) classname += ' past'
										const isSelected = day_k === 2
										const hasDispo = this._hasAvailableSlotCart(time) && !_isComplet(this._remainingStockForDay(time))
										return (
											<div className={classname} key={day_k}
												onClick={day_k !== 2 && !isPast ? () => { this.updateTime(time); this.setState({ selectedSlotCart: null }) } : undefined}>
												<span className="day-txt">{dayTxt}</span>
												<strong>{dayNb}</strong>
												<span style={{ display: 'block', fontSize: '0.75em' }}>{monthTxt}</span>
												{hasDispo && <span className="day-dot" style={isSelected ? { backgroundColor: themeColor } : {}} />}
											</div>
										)
									})}
								</div>
								<div style={{ clear: 'both' }}></div>
							</div>
							<div className="Dates slots">
								{checkSlotsAvailable.open === false
									? <><p className="unavailable">{checkSlotsAvailable.msg}</p>{nextAvailableBtnCart}</>
									: renderSlots(true)
								}
							</div>
							{confirmBarJSX}
						</div>
					)
				}

				// Vue cartes Aujourd'hui / Demain
				const todayDate = new Date(todayMidnight * 1000)
				const tomorrowDate = new Date(tomorrowMidnight * 1000)
				const todayDayTxt = time_assets.weekdays_short[todayDate.getDay()]
				const todayDayNb = String(todayDate.getDate()).padStart(2, '0')
				const todayMonthTxt = time_assets.months_short[todayDate.getMonth()]
				const tomorrowDayTxt = time_assets.weekdays_short[tomorrowDate.getDay()]
				const tomorrowDayNb = String(tomorrowDate.getDate()).padStart(2, '0')
				const tomorrowMonthTxt = time_assets.months_short[tomorrowDate.getMonth()]

				return (
					<div className="min-h-4/5-screen">
						<div className="flex flex-col justify-center items-center z-0 w-full fixed top-0 h-28 px-6" style={{ backgroundColor: themeColor }}>
							<p className="text-white text-sm font-medium" style={{ opacity: 0.75 }}>{lang_assets.your_order}</p>
							<h1 className="text-white text-2xl font-bold mt-1">{lang_assets.choose_slot}</h1>
						</div>
						<div className="bg-white w-full mt-24 min-h-9/10-screen absolute rounded-t-3xl" style={{ paddingBottom: 'calc(var(--vh, 1vh) * 10 + 5rem)' }}>

							{/* Cartes Aujourd'hui / Demain */}
							<div className="grid grid-cols-2 gap-3 mx-4 mt-6">
								{[
									{ label: time_assets.today, dayTxt: todayDayTxt, dayNb: todayDayNb, monthTxt: todayMonthTxt, hasSlots: todayHasSlots, isComplet: todayIsComplet, count: todayCount, key: 'today', ts: todayMidnight },
									{ label: time_assets.tomorrow, dayTxt: tomorrowDayTxt, dayNb: tomorrowDayNb, monthTxt: tomorrowMonthTxt, hasSlots: tomorrowHasSlots, isComplet: tomorrowIsComplet, count: tomorrowCount, key: 'tomorrow', ts: tomorrowMidnight }
								].map(({ label, dayTxt, dayNb, monthTxt, hasSlots, isComplet, count, key, ts }) => {
									const isSelected = selectedDayCard === key
									const isDisabled = !hasSlots || isComplet
									const cardStyle = !isDisabled && isSelected ? { borderColor: themeColor, backgroundColor: themeColor + '12' } : {}
									return (
										<div key={key}
											onClick={!isDisabled ? () => this.setState({ selectedDayCard: key, timestamp: ts, selectedSlotCart: null }) : undefined}
											className={'rounded-2xl border-2 p-4 transition-all ' + (isDisabled ? 'border-gray-100 bg-gray-50' : isSelected ? '' : 'border-gray-200 bg-white cursor-pointer')}
											style={cardStyle}>
											<p className="text-xs font-semibold text-gray-400 uppercase tracking-wide">{label}</p>
											<p className={'text-lg font-bold mt-1 ' + (isDisabled ? 'text-gray-300' : 'text-gray-800')}>{dayTxt}. {dayNb} {monthTxt}</p>
											{isComplet
												? <p className="text-sm font-medium text-gray-300 mt-2">{lang_assets.full}</p>
												: hasSlots
												? <p className="text-sm font-medium mt-2" style={{ color: themeColor }}>{count} {count > 1 ? lang_assets.slot_many : lang_assets.slot_one}</p>
												: <p className="text-sm font-medium text-gray-300 mt-2">{lang_assets.closed}</p>
											}
										</div>
									)
								})}
							</div>

							{/* Slots inline si une carte est sélectionnée */}
							{(selectedDayCard === 'today' || selectedDayCard === 'tomorrow') && (
								<div className="mx-4 mt-5">
									{renderSlots(false)}
								</div>
							)}

							{/* Séparateur */}
							<div className="flex items-center gap-3 mx-4 mt-6">
								<div className="flex-1 h-px bg-gray-200" />
								<span className="text-xs text-gray-400 font-medium">{lang_assets.or}</span>
								<div className="flex-1 h-px bg-gray-200" />
							</div>

							{/* Une autre date */}
							<button type="button"
								onClick={() => this.setState({ selectedDayCard: 'other' })}
								className="w-full flex items-center justify-between px-4 mt-4 py-2">
								<span className="text-base font-medium text-gray-700"><span role="img" aria-label="Calendrier">📅</span> {lang_assets.other_date}</span>
								<span className="text-gray-400 text-lg mr-2">→</span>
							</button>

							{confirmBarJSX}
						</div>
					</div>
				)
			}
			else if (this.state.step === 2)
			{
				return (
					<Buying
						pathname={this.props.history.location.pathname}
						user={this.props.user}
						updateShell={this.props.updateShell}
						updateLogs={this.props.updateLogs}
						reservation={this.state.reservation}
						service={this.state.service}
						service_benefit={this.state.service_benefits ? this.state.service_benefits[0] : null}
						cart={this.state.cart}
						theme={this.props.theme}
						lang_assets={this.props.lang_assets}
						postServiceReservationCart={this.props.postServiceReservationCart}
						createServicePaymentIntent={this.props.createServicePaymentIntent}
						postUpdateBirthday={this.props.postUpdateBirthday}
						postUpdatePhone={this.props.postUpdatePhone}
						onEditCart={() => this.setState({ step: 1 })}
					/>
				)
			}
			else
			{
				return (
					<Skeleton variant="cards" />
				)
			}
		}
		else
		{
			return (
				<Skeleton variant="cards" />
			)
		}
	}
}

export default Services